<template>
	<div id="side-menu">
		<div class="visible-xs visible-sm sidebar-close">
			<button type="button" class="close" data-toggle="collapse" data-target="#left-menu"><i class="las la-times"></i></button>
		</div>
		<div v-if="hasReservationPermission" id="section-reservation">
			<h4 class="margin-bottom-10">{{ $t('sidemenu.reservations') }}</h4>
			<ul class="nav nav-pills nav-stacked">
				<li role="presentation">
					<router-link to="/calendar">
						<i class="las la-calendar"></i>
						{{ $t('sidemenu.calendar') }}
					</router-link>
				</li>
				<li role="presentation">
					<router-link to="/reservations">
						<i class="las la-calendar-check"></i>
						{{ $t('sidemenu.reservations') }}
					</router-link>
				</li>
				<li role="presentation">
					<router-link to="/appointments">
						<i class="las la-user-clock"></i>
						{{ $t('sidemenu.appointments') }}
					</router-link>
				</li>
				<li id="clients-link" role="presentation">
					<router-link to="/clients">
						<i class="las la-address-book"></i>
						{{ $t('sidemenu.customers') }}
					</router-link>
				</li>
			</ul>
		</div>
		<div v-if="hasAdministrationPermission" class="margin-top-40" id="section-administration">
			<h4 class="margin-bottom-10">{{ $t('sidemenu.administration') }}</h4>
			<ul class="nav nav-pills nav-stacked">
				<li id="cash-report-link" role="presentation" class="hide">
					<router-link to="/cash_report">
						<i class="las la-cash-register"></i>
						{{ $t('sidemenu.cashier_summary') }}
					</router-link>
				</li>
				<li id="transaction-link" role="presentation">
					<router-link to="/transactions">
						<i class="las la-shopping-cart"></i>
						{{ $t('sidemenu.sales') }}
					</router-link>
				</li>
                <li id="statement-link" role="presentation">
                    <router-link to="/statement">
                        <i class="las la-coins"></i>
                        {{ $t('sidemenu.statement') }}
                    </router-link>
                </li>
				<li id="payouts-link" role="presentation">
					<router-link to="/payouts">
						<i class="las la-money-bill"></i>
						{{ $t('sidemenu.payouts') }}
					</router-link>
				</li>
				<li id="fee-log-link" role="presentation" class="hide">
					<router-link to="/fee_log">
						<i class="las la-calendar-day"></i>
						{{ $t('sidemenu.fee_log') }}
					</router-link>
				</li>
				<li id="analytics-link" role="presentation" class="hide">
					<router-link to="/analytics">
						<i class="las la-chart-bar"></i>
						{{ $t('sidemenu.analytics') }}
					</router-link>
				</li>
			</ul>
		</div>
		<div v-if="hasConfigurationPermission" class="margin-top-40" id="section-settings">
			<h4 class="margin-bottom-10">{{ $t('sidemenu.configurations') }}</h4>
			<ul class="nav nav-pills nav-stacked">
				<li id="rates-link" role="presentation">
					<router-link to="/rates">
						<i class="las la-calculator"></i>
						{{ $t('sidemenu.rates') }}
					</router-link>
				</li>
				<li id="subscriptions-link" role="presentation">
					<router-link to="/subscriptions/type">
						<i class="las la-wallet"></i>
						{{ $t('sidemenu.subscriptions_carnet') }}
					</router-link>
				</li>
				<li id="events" role="presentation" class="hide">
					<router-link to="/events">
						<i class="las la-users"></i>
						{{ $t('sidemenu.events') }}
					</router-link>
				</li>
				<li id="content" role="presentation" v-if="hasEnabledVideoFeature">
					<router-link to="/content">
						<i class="las la-box"></i>
						{{$t('views.content.title')}}
					</router-link>
				</li>
				<li id="marketing" role="presentation">
					<router-link to="/marketing">
						<i class="las la-bullhorn"></i>
						Marketing
					</router-link>
				</li>
				<li id="account-settings-link" role="presentation">
					<router-link to="/settings">
						<i class="las la-cog"></i>
						{{ $t('sidemenu.settings') }}
					</router-link>
				</li>
				<li id="widget-link" role="presentation" class="hide">
					<router-link to="/developers">
						<i class="las la-terminal"></i>
						{{ $t('sidemenu.developers') }}
					</router-link>
				</li>
			</ul>
		</div>
		<ul class="nav nav-pills nav-stacked pushed-down" v-if="user">
			<li id="account-link" role="presentation" class="margin-bottom-20" >
				<router-link to="/account">
					<i class="las la-user-circle"></i>
					{{user.email}}
				</router-link>
			</li>
			<li role="presentation">
				<a href="" @click.prevent.stop="logout" id="logout_button">
					<i class="las la-door-open"></i>
					{{ $t('sidemenu.logout') }}
				</a>
			</li>
			<li role="presentation" class="disabled" style="padding-left:30px;">
				<a href="#">
					v 1.2
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	import {StorageHelper} from "../../common/storageHelper";
	import {CLIENT_ADMIN_PERMISSION} from "../../common/constants";

	export default {
		name: "SideMenu",
		computed: {
			// a computed getter
			hasAdministrationPermission: function () {
				// `this` points to the vm instance
				return StorageHelper.getUser().read_permissions.includes(CLIENT_ADMIN_PERMISSION.ADMINISTRATION)
			},
			hasReservationPermission: function () {
				// `this` points to the vm instance
				return StorageHelper.getUser().read_permissions.includes(CLIENT_ADMIN_PERMISSION.RESERVATION)
			},
			hasConfigurationPermission: function () {
				// `this` points to the vm instance
				return StorageHelper.getUser().read_permissions.includes(CLIENT_ADMIN_PERMISSION.CONFIGURATION)
			},

            hasEnabledVideoFeature: function () {
                return StorageHelper.getUser().company.feature_video || false
            },

			user: function () {
				return StorageHelper.getUser()
			}
		},
		methods: {
			logout() {
				StorageHelper.setToken(null);
				StorageHelper.setUser(null);
				this.$router.push({ name: "login" });
			}
		}
	};
</script>
